import axios from 'axios';
import AppConfig from "../../../../../AppConfig";

let URL = AppConfig.HOST_API()+'dataRodzKal/';

export default {

    getDatyZKalendarzami(start,koniec) {
        return axios({
            method: 'get',
            url: URL + 'search/'+start+'/'+koniec,
        });
    },

    editKalendarzDoDaty(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },
    startProceduraGeneruj(start,koniec){
        return axios({
            method: 'get',
            url: URL + 'pWypelnijDataRodzKal?dataOd='+start+'&dataDo='+koniec,
        });
    },

    pobierzDatyOkresowe(){
        return axios({
            method: 'get',
            url: AppConfig.HOST_API()+ 'konfig/getRozkladDataOdDataDo',
        });
    },

    zmienDatyOkresowe(start,koniec){
        return axios({
            method: 'post',
            url: AppConfig.HOST_API()+ 'konfig/setRozkladDataOdDataDo?dataOd='+start+'&dataDo='+koniec,
        });
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/kalendarze/przypisanieKalendarzaDoDaty/KalendarzDoDatyService.js